/**
 * @generated SignedSource<<0c317082b607e918ab039971c20c5d86>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardInlineCreate_query$data = {
  readonly jira_categoryField: {
    readonly fieldId: string;
  } | null | undefined;
  readonly " $fragmentType": "BoardInlineCreate_query";
};
export type BoardInlineCreate_query$key = {
  readonly " $data"?: BoardInlineCreate_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardInlineCreate_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BoardInlineCreate_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "jira_categoryField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "fieldId"
          },
          "action": "THROW",
          "path": "jira_categoryField.fieldId"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "4dfc27c25aea596e27407b31fa9c26db";

export default node;
